@if (!!key) {
  <div id="store-finder-widget" [attr.data-key]="key" [attr.data-baseurl]="baseUrl"></div>
}
